import { BASE_COLORS } from "config/theme/constants";
import styled from "styled-components";

export const TimeFilterWrapper = styled.div`
  .ant-statistic-content {
    font-size: 16px;
  }
  .ant-radio-button-wrapper {
    border: none !important;
    background-color: rgb(249 250 251);
    padding: 8px 12px;
    height: auto;
    &:before {
      display: none;
    }
    &:hover{
       color: ${BASE_COLORS.curiousBlue};
    }
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    background: white !important;
    border-color: white !important;
  }
  .ant-radio-button-wrapper-checked {
    background: white !important;
    padding: 4px 10px;
    border-radius: 8px;
    border: 1px solid transparent !important;
    span {
      color: ${BASE_COLORS.curiousBlue};
      font-weight: 600;
    }
  }
  .ant-radio-group {
    border: 1px solid transparent;
    background-color: rgb(249 250 251);
    border-radius: 8px;
    padding: 0px 4px;
  }
`;